import { useEffect, useState } from 'react'
import styled from 'styled-components'
import BookMineListRange from './BookMineListRange'
import IndexContentContainer from '../../index/IndexContentContainer'
import { Form } from 'react-bootstrap'
import useUrlQuery from '../../../common/hooks/useUrlQuery'
import { BooksitoutServer } from '../../../config/BooksitoutServer'
import breakpoints from '../../../config/Breakpoints'

const BookMineRangeSelector = () => {
	const range = (useUrlQuery('range') ?? 'READING') as BookMineListRange
	const [counts, setCounts] = useState<Record<string, number | null>>({ READING: null, DONE: null, GIVEUP: null })

	useEffect(() => {
		const ranges = ['READING', 'DONE', 'GIVEUP']
		ranges.forEach(r => {
			BooksitoutServer.get(`/v1/book/my-book?range=${r}&page=1&size=1`).then(res => {
				setCounts(prev => ({ ...prev, [r]: res.data.totalCount ?? null }))
			})
		})
	}, [])

	const buttons = [
		{
			url: '/book/mine?range=READING',
			key: 'READING',
			label: '읽는 중',
		},
		{
			url: '/book/mine?range=DONE',
			key: 'DONE',
			label: '다 읽음',
		},
		{
			url: '/book/mine?range=GIVEUP',
			key: 'GIVEUP',
			label: '포기',
		},
	]

	return (
		<Container>
			<Label>책 범위</Label>

			<FormContainer>
				<Form.Group>
					<RangeButtonContainer>
						{buttons.map(button => (
							<RangeButton key={button.key} href={button.url} className={`${range?.toUpperCase() == button.key ? 'text-book fw-bold' : ''}`} range={range} buttonKey={button.key} color="var(--primary-color)">
								{button.label}
								<Count className={range?.toUpperCase() == button.key ? 'text-book' : ''}>{counts[button.key] ?? '\u00A0'}</Count>
							</RangeButton>
						))}
					</RangeButtonContainer>
				</Form.Group>
			</FormContainer>
		</Container>
	)
}

const Container = styled(IndexContentContainer)`
	display: flex;
	align-items: center;
	justify-content: left;
	width: fit-content;

	color: black;

	padding-top: 26px;
	padding-bottom: 24px;

	&:hover {
		color: black;
	}
`

const Label = styled.h5`
	padding: 3px 0 0;
	margin: 0;
	font-size: 25px;
	white-space: nowrap;

	&:hover {
		color: var(--text-color);
	}

	color: var(--text-color);

	@media (max-width: ${breakpoints.sm}) {
		display: none;
	}
`

const RangeButtonContainer = styled.h6`
	padding: 14px 0 0;
	margin: 0;
	display: flex;
	flex-wrap: wrap;

	@media (max-width: ${breakpoints.sm}) {
		padding-top: 0;
	}
`

const RangeButton = styled.a<{ range?: string; buttonKey: string; color: string }>`
	min-width: 30px;
	margin: 0;
	padding-left: 10px;
	padding-right: 10px;
	color: ${({ range, buttonKey, color }) => (range?.toUpperCase() === buttonKey ? color : 'var(--text-color)')};
`

const Count = styled.span`
	font-size: 12px;
	color: var(--sub-text-color);
	margin-left: 2px;
	display: inline-block;
	min-width: 22px;
`

const FormContainer = styled(Form)`
	flex: 1;
`

export default BookMineRangeSelector
